module.exports = new __parcel__URL__("capacity-app-skeleton.tpl.61191f22.svg").toString();